export default "__VITE_ASSET__CjGcEsyH__"